<template>
    <div class="custom-div-select-parent">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: "CustomDivSelect",
};
</script>

<style>
.custom-div-select-parent {
    position: absolute;
    bottom: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    background-color: #ffffff;
}

.custom-div-select-parent * {
    color: #6c6c6c;
    cursor: pointer;
    /* padding: calc(10px + 1px * var(--window-devicePixelRatio)); */
    padding: 10px;
    background-clip: border-box;
}

.custom-div-select-parent *:hover {
    color: #000000;
}
</style>
